export default {
  dataInicio: {
    value: new Date(),
    required: true,
    state: null
  },
  dataFim: {
    value: new Date(),
    required: true,
    state: null
  },
  contratoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  obraReferencia: {
    value: null,
    required: false,
    state: null
  },
  funcionarioID: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/pdr/pdrarchived-form.js